/**
 * Returns the substring following the prefix, or undefined if the value does not start with the prefix.
 */
export const getPrefixedValue = (value: string, prefix: string): string | null => {
  if (value.startsWith(prefix)) {
    return value.substring(prefix.length);
  }

  return null;
};

export const parseBoolean = (s: string | boolean | number): boolean =>
  s === 'true' || s === true || parseInt(String(s), 10) === 1;

export const containsWhiteSpace = (s: string): boolean => /\s/.test(s);

export const secondsToDisplayTime = (duration: number): string => {
  if (duration >= 3600)
    return new Date(duration * 1000).toISOString().substr(12, 7);
  if (duration >= 600)
    return new Date(duration * 1000).toISOString().substr(14, 5);
  return new Date(duration * 1000).toISOString().substr(15, 4);
};

export const displayTimeToSeconds = (timeString: string | null | undefined): number | null => {
  if (!timeString || typeof timeString !== 'string') return null;

  return timeString
    .split(':')
    .reverse()
    .reduce(
      (accumulator, current, index) =>
        accumulator + 60 ** index * parseInt(current, 10),
      0,
    );
};

export const appendLeadingZeroesToNum = (input: string | number, totalDigits: number): string => {
  let result = input;
  let inputLength;
  if (typeof input === 'string') {
    result = Number(input);
    inputLength = input.length;
  } else {
    inputLength = input.toString().length;
  }
  if (inputLength < totalDigits) {
    const digitsToAppend = totalDigits - inputLength;
    result = '0'.repeat(digitsToAppend) + result;
  }
  return typeof result === 'string' ? result : result.toString();
};

export const isEmptyOrNull = (str: string | null): boolean => {
  return str === '' || str === null;
};
